@if (doctorList) {
  <span>
    @for (list of doctorList; track list) {
      <div (click)="openVideoCall(list)"
        class="col-12 float-left p-top-section pl-2 pr-2 pt-2">
        <!-- <div class="p-image">
        <img src="./assets/images/user-profile-image.png">
        <i [ngClass]="list.is_online?'text-primary':'text-danger'" class="fa fa-circle" aria-hidden="true"></i>
      </div> -->
      <div class='icon-container'>
        <img src="./assets/images/user-profile-image.png" />
        <div class='status-circle' [ngStyle]="list.is_online?{'background':'#93ef93'}:{'background':'grey'}"></div>
      </div>
      <div class="patient-details">
        <p class="p-name text-capitalize cursor-pointer">{{list.display_name}}</p>
        <p class="speciality">{{list.speciality}}</p>
      </div>
    </div>
  }
</span>
}